<div class="image-slider-container" [style]="card.flex">
  <div class="image-slider" [style]="card.cssStyle">
    <img [src]="card.img" [alt]="alt" [style]="getImgStyle()" style="filter: brightness(0.95);">
  </div>
</div>
